{
    "AllTelServer": "[Alle Telefonieserver]",
    "AnyPartition": "[Jede Partition]",
    "AnyDevices": "[Jedes Gerät]",
    "AnyAgents": "[Jeder ACD-Agent]",
    "AnyAgentForDevice": "[Jedes am eingestellten Gerät]",
    "AnyDeviceForAgent": "[Beliebig mit eingestelltem ACD-Agent]",
    "DeviceValidation": "Ein Administrator kann keine Geräteberechtigungsstufe festlegen",
    "AgentValidation": "Ein Administrator kann keine Berechtigungsstufe für Agenten festlegen",
    "PermissionsLanguage_PermissionsNote": "Legen Sie die Berechtigungen für die Benutzerzugriffsebene fest.",
    "PermissionsLanguage_CmEnvironment": "CME:",
    "PermissionsLanguage_TelServer": "Telefonieserver:",
    "PermissionsLanguage_Partition": "Teilung:",
    "PermissionsLanguage_Device": "Gruppe\/Gerät:",
    "PermissionsLanguage_AndOrAgent": "Agent:",
    "NAME": "PermissionsLanguage",
    "EssentialsDeviceValidation": "Für diesen Benutzertyp muss ein Berechtigungsgerät festgelegt sein",
    "EssentialsDeviceValidation_MST": "Ein CXA-Standard-Benutzer muss ein Berechtigungsgerät haben",
    "PermissionsLanguage_SynchroniseSupervisorPermissions": "Synchronisierung der Supervisor-Berechtigungen von der Telefonie-Plattform"
}